<template>
  <div class="tabs-head">
      <slot></slot>
      <span class="line" id="g-line" ref="line"></span>
      <div class="button-wrapper">
          <slot name="button"></slot>
      </div>
  </div>
</template>

<script>
export default {
    name: 'g-tabs-head',
    inject:['eventBus'],
    mounted() {
        this.eventBus.$on('update:selected',(name,vm) => {
            document.body.appendChild(this.$refs.line)
            const {width, left, top,height} = vm.$el.getBoundingClientRect()
            this.$refs.line.style.width = `${width}px`
            this.$refs.line.style.left = `${left}px`
            this.$refs.line.style.top = `${top+height}px`
        })
        
    },
}
</script>

<style lang="scss" scoped>
@import '../var';
.tabs-head{
    display: flex;
    height: $height;
    line-height: $height;
    // justify-content: center;
    align-items: center;
    position: relative;
    border-bottom:2px solid #ddd;
    >.button-wrapper{
        margin-left:auto;
    }
    >.line{
        position:absolute;
        bottom:-2px;
        border-bottom:2px solid $blue;
        transition: all 250ms;
    }
}
.line{
    position:absolute;
    bottom:-2px;
    border-bottom:2px solid $blue;
    transition: all 250ms;
    height:2px;
}
</style>